import { Link } from "react-router-dom";
import { Layout } from "../components/Layout";
import { LoadingWrapper, HeroSkeleton } from "../components/LoadingWrapper";
import three from "../assets/home/three.svg";

const HomePage: React.FC = () => {
  return (
    <LoadingWrapper 
      loadingDuration={1500}
      skeletonComponent={<HeroSkeleton />}
    >
      <Layout>
        <div className="flex-1 relative">
          {/* Background Image */}
          <div
            className="absolute inset-0 z-0"
            style={{
              backgroundImage: `url(${three})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}>
            {/* Dark Overlay */}
            <div className="absolute inset-0 bg-black/50"></div>
          </div>

          {/* Content */}
          <div className="absolute inset-0 z-10 flex flex-col items-center justify-center text-center px-4 md:px-8">
            <h1 className="text-3xl md:text-5xl font-normal text-white max-w-4xl mb-6">
              CLIMATE-RELATED RISKS ASSESSMENT TOOL FOR CRDB BANK'S AGRICULTURE
              LOANS PORTFOLIO.
            </h1>

            <p className="text-lg md:text-lg text-white max-w-3xl mb-12">
              Integrating Climate Risk Reduction And Adaptation Strategies To
              Enhance Resilience And Support Informed Credit Assessment Decisions.
            </p>

            <Link to="/dashboardcard">
              <button className="bg-lime-100 hover:bg-white text-white hover:text-lime-100 px-8 py-3 rounded-3xl flex items-center space-x-2 transition-colors">
                <span>EXPLORE DATA</span>
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </button>
            </Link>
          </div>
        </div>
      </Layout>
    </LoadingWrapper>
  );
};

export default HomePage;
